import { TApplicationState } from '../../types/redux';
import { isAbUseExperimentGroup } from '../../utils/experiments';
import { NEWBUILDING_TRUST_AND_SAFETY } from '../../constants/experiments';

export const isReliabilityEnabledSelector = (state: TApplicationState): boolean => {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, NEWBUILDING_TRUST_AND_SAFETY, 'enabled');
};
